import React, { useContext } from "react";
import { ModalContext } from "../../store/modal-context";
import AddBoardModal from "../AddBoard/AddBoardModal";
import EditBoard from "../EditBoard/EditBoard";
import DeleteBoard from "../DeleteBoard/DeleteBoard";
import AddNewTask from "../AddNewTask/AddNewTask";
import ViewTask from "../ViewTask/ViewTask";
import EditTask from "../EditTask/EditTask";
import DeleteTask from "../DeleteTask/DeleteTask";

// Mounted once so that only a single instance of the currently open modal
// ever renders, even though BoardsAll keeps every board mounted at once.
const ModalSwitchboard = () => {
  const { modalType } = useContext(ModalContext);

  switch (modalType) {
    case "addBoard":
      return <AddBoardModal />;
    case "editBoard":
      return <EditBoard />;
    case "deleteBoard":
      return <DeleteBoard />;
    case "addTask":
      return <AddNewTask />;
    case "viewTask":
      return <ViewTask />;
    case "editTask":
      return <EditTask />;
    case "deleteTask":
      return <DeleteTask />;
    default:
      return null;
  }
};

export default ModalSwitchboard;
